<p-toast></p-toast>

<p-panel header="Черга на розгляд">
  <!-- Merged control row: actions on left, reload button on right.
       Positioned outside the *ngIf gate so "Оновити" stays reachable while loading.
       Controls are always rendered and only enabled/disabled by the selection --
       never hidden, so the bar does not change shape as the selection moves.
       Same reasoning as agent-dashboard's own bar. -->
  <div class="flex align-items-center justify-content-between gap-2 mb-3 flex-wrap">
    <div class="flex align-items-center gap-2 flex-wrap">
      <!-- appendTo="body": see the note on agent-dashboard's own reason dropdown. -->
      <p-dropdown [options]="resolveActions" optionLabel="title" optionValue="value"
                  placeholder="Рішення..." [(ngModel)]="selectedResolveAction"
                  [disabled]="!selectedQueueItem || queueSelectionBusy" styleClass="p-inputtext-sm" appendTo="body"></p-dropdown>
      <button pButton pRipple type="button" label="Застосувати" icon="pi pi-check" class="p-button-sm"
              [disabled]="!canResolveSelected" (click)="onResolve(selectedQueueItem)"
              pTooltip="Застосувати рішення -- потрібно вибрати варіант" tooltipPosition="top"></button>

      <span *ngIf="!selectedQueueItem" class="text-500 ml-2">Виберіть рядок</span>
    </div>
    <p-button icon="pi pi-refresh" label="Оновити" styleClass="p-button-success" (onClick)="loadQueue()"
              pTooltip="Оновити чергу на розгляд" tooltipPosition="top"></p-button>
  </div>

  <div *ngIf="queueLoaded; else queueLoading">
    <p-table #ptableQueue [value]="queue" [rowHover]="true"
             selectionMode="single" [(selection)]="selectedQueueItem"
             [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50,100]"
             [showCurrentPageReport]="true" currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} записів"
             sortMode="single" dataKey="id" [resizableColumns]="true"
             styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn pSortableColumn="requestId" style="width: 5rem"># <p-sortIcon field="requestId"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="detectedAt">Виявлено <p-sortIcon field="detectedAt"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="spamReason">Причина <p-sortIcon field="spamReason"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="senderEmail">Відправник <p-sortIcon field="senderEmail"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="subject">Тема <p-sortIcon field="subject"></p-sortIcon></th>
        </tr>
        <tr>
          <th><input pInputText type="text" [(ngModel)]="cfQueue['requestId']" (input)="ptableQueue.filter($event.target.value, 'requestId', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfQueue['detectedAt']" (input)="ptableQueue.filter($event.target.value, 'detectedAt', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfQueue['spamReason']" (input)="ptableQueue.filter($event.target.value, 'spamReason', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfQueue['senderEmail']" (input)="ptableQueue.filter($event.target.value, 'senderEmail', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfQueue['subject']" (input)="ptableQueue.filter($event.target.value, 'subject', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td class="font-bold">{{item.requestId}}</td>
          <td>{{item.detectedAt | date:'dd.MM.yyyy HH:mm'}}</td>
          <td>
            <p-tag [severity]="item.spamReason === 'sender_blocked' ? 'danger' : 'secondary'"
                   [value]="item.spamReason === 'sender_blocked' ? 'авто-блок' : (item.spamReason === 'manual' ? 'вручну' : item.spamReason)"></p-tag>
          </td>
          <td>{{item.senderEmail || '—'}}</td>
          <td>{{item.subject || '—'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="5">Черга порожня</td></tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template #queueLoading>
    <p>Дані завантажуються...</p>
  </ng-template>
</p-panel>

<p-panel header="Заблоковані відправники" styleClass="mt-3">
  <!-- Merged control row: filter and action on left, reload button on right.
       Positioned outside the *ngIf gate so "Оновити" stays reachable while loading.
       Always rendered, enabled only for a selected sender that is actually
       auto-blocked -- see the queue bar above. -->
  <div class="flex align-items-center justify-content-between gap-2 mb-3 flex-wrap">
    <div class="flex align-items-center gap-2 flex-wrap">
      <label for="ASQ1" class="do-not-wrap-text">
        <p-checkbox id="ASQ1" [binary]="true" [(ngModel)]="sendersAutoBlockOnly" (onChange)="onAutoBlockFilterChange()"></p-checkbox>
        Тільки активно заблоковані
      </label>

      <button pButton pRipple type="button" label="Розблокувати" icon="pi pi-unlock" class="p-button-sm p-button-outlined"
              [disabled]="!canUnblockSelected" (click)="onUnblock(selectedSender)"
              pTooltip="Скинути авто-блокування для цього відправника" tooltipPosition="top"></button>

      <span *ngIf="!selectedSender" class="text-500 ml-2">Виберіть рядок</span>
    </div>
    <p-button icon="pi pi-refresh" label="Оновити" styleClass="p-button-success" (onClick)="loadSenders()"
              pTooltip="Оновити список відправників" tooltipPosition="top"></p-button>
  </div>

  <div *ngIf="sendersLoaded; else sendersLoading">
    <p-table #ptableSenders [value]="senders" [rowHover]="true"
             selectionMode="single" [(selection)]="selectedSender"
             [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50,100]"
             [showCurrentPageReport]="true" currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} відправників"
             sortMode="single" dataKey="id" [resizableColumns]="true"
             styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn pSortableColumn="senderEmail">Відправник <p-sortIcon field="senderEmail"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="occurrenceCount">Кількість позначень <p-sortIcon field="occurrenceCount"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="lastSeenAt">Останнє звернення <p-sortIcon field="lastSeenAt"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="markedByName">Позначив <p-sortIcon field="markedByName"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="autoBlock">Статус <p-sortIcon field="autoBlock"></p-sortIcon></th>
        </tr>
        <tr>
          <th><input pInputText type="text" [(ngModel)]="cfSenders['senderEmail']" (input)="ptableSenders.filter($event.target.value, 'senderEmail', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfSenders['occurrenceCount']" (input)="ptableSenders.filter($event.target.value, 'occurrenceCount', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfSenders['lastSeenAt']" (input)="ptableSenders.filter($event.target.value, 'lastSeenAt', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th><input pInputText type="text" [(ngModel)]="cfSenders['markedByName']" (input)="ptableSenders.filter($event.target.value, 'markedByName', 'contains')" placeholder="Пошук" class="p-column-filter"></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-sender>
        <tr [pSelectableRow]="sender">
          <td class="font-bold">{{sender.senderEmail}}</td>
          <td>{{sender.occurrenceCount}}</td>
          <td>{{sender.lastSeenAt | date:'dd.MM.yyyy HH:mm'}}</td>
          <td>{{sender.markedByName || '—'}}</td>
          <td>
            <p-tag [severity]="sender.autoBlock ? 'danger' : 'success'"
                   [value]="sender.autoBlock ? 'заблоковано' : 'активний'"></p-tag>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="5">Немає відправників</td></tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template #sendersLoading>
    <p>Дані завантажуються...</p>
  </ng-template>
</p-panel>
